"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricQueryTypeEnum = void 0;
var MetricQueryTypeEnum;
(function (MetricQueryTypeEnum) {
    MetricQueryTypeEnum["Max"] = "MAX";
    MetricQueryTypeEnum["Min"] = "MIN";
    MetricQueryTypeEnum["Sum"] = "SUM";
    MetricQueryTypeEnum["Add"] = "ADD";
    MetricQueryTypeEnum["Diff"] = "DIFF";
    MetricQueryTypeEnum["SumMax"] = "SUMMAX";
    MetricQueryTypeEnum["Static"] = "Static";
    MetricQueryTypeEnum["Percent"] = "Percent";
    MetricQueryTypeEnum["Avg"] = "AVG";
    MetricQueryTypeEnum["Least"] = "LEAST";
    MetricQueryTypeEnum["Greatest"] = "GREATEST";
})(MetricQueryTypeEnum = exports.MetricQueryTypeEnum || (exports.MetricQueryTypeEnum = {}));
